export enum MfaStep {
	default = 'DEFAULT',
	pushSetup = 'PUSH_SETUP',
	callSetup = 'CALL_SETUP',
	textSetup = 'TEXT_SETUP',
}